// 로켓등록 화면 조회 기간(YYYY-MM-DD)이 오늘을 포함하게 늘린다 — 시작일은 그대로 둔다(어제 것도 계속 보인다).
// 대기열이 도는 사이 자정을 넘기면 기간이 어제에 머물러, 저장 직후 search() 가 오늘 만든 상품을 목록에서 빼고
// 작업개시가 「제품을 찾을 수 없습니다」로 끝났다(PR261017-62FA8B). 이 파일은 의존성이 없다(단위 시험이 그대로 올린다).
export function listRangeIncludingToday(startdate, enddate, today) {
    let start = startdate;
    let end = enddate;
    let changed = false;
    if (!end || end < today) { end = today; changed = true; }
    if (!start || start > today) { start = today; changed = true; }
    return { startdate: start, enddate: end, changed };
}
